<script setup lang="ts">
import { toast } from 'vue-sonner'

const { loginWithGoogle, authError } = useLogin()
const { isLoginHintVisible, closeLoginHint } = useLoginHint()
const $route = useRoute()
const $router = useRouter()
const localePath = useLocalePath()

function toggleVisible(show: boolean) {
  if (!show)
    closeLoginHint()
}

async function signIn() {
  localStorage.setItem('prevRoute', $route.fullPath)
  await loginWithGoogle()
}

// function loginSuccessRedirect() {
//   const hasPrevRoute = localStorage.getItem('prevRoute')
//   const route = hasPrevRoute || redirectUrl.value || '/'
//   $router.push(localePath(route))
//   localStorage.removeItem('prevRoute')
//   toast.success('登入成功')
// }

function redirectToPage(path: string) {
  toggleVisible(false)
  $router.push(localePath(path))
}

watch(authError, (err) => {
  if (err)
    toast.error(`登入失敗: ${err.message}`)
})
</script>

<template>
  <ui-drawer v-model:open="isLoginHintVisible">
    <ui-drawer-content class="pb-safe">
      <ui-drawer-header>
        <ui-drawer-title>
          <p class="text-base text-center py-4 font-bold">
            登入
          </p>
        </ui-drawer-title>
        <ui-drawer-description>
          <p class="text-base text-center px-8 mt-6">
            登入會員帳號以分享或回覆令你感觸的故事，留下一些足跡，持續啟發
          </p>
        </ui-drawer-description>
      </ui-drawer-header>

      <div class="px-6">
        <ui-button
          class="mt-6 py-4 w-full h-auto rounded-full"
          @click="signIn"
        >
          <i
            i-flat-color-icons-google
            class="mr-2 inline-block scale-150"
          />
          <span class="ml-2">使用 Google 登入</span>
        </ui-button>
        <p class="text-center text-neutral-500 mt-10 pb-8">
          註冊即表示同意我們的<span class="underline" @click="redirectToPage('/terms')">服務約定條款</span>
        </p>
      </div>
    </ui-drawer-content>
  </ui-drawer>
</template>
